import { useState, useEffect, useRef } from "react";
import { sortLeftRightTopBottom } from "../../../refractCommon/miro/sortLeftRightTopBottom";
const { board } = window.miro;

function Scale({ boardSelection }) {
  const [scaleAmount, setScaleAmount] = useState(1);
  const [scaleItems, setScaleItems] = useState([]);
  const [scaleInPlacechecked, setScaleInPlacechecked] = useState(false);
  const [toolOpen, setToolOpen] = useState(false);
  const [setHeight, setHeightState] = useState("0px");

  const content = useRef(null);

  useEffect(() => {
    runSelectItemsForScale(boardSelection);
  }, [boardSelection]);

  function handleToggleOpen() {
    setToolOpen(!toolOpen);
    setHeightState(toolOpen ? "0px" : `${content.current.scrollHeight}px`);
  }

  function handleScaleInPlaceChange() {
    setScaleInPlacechecked(!scaleInPlacechecked);
  }

  // S C A L E
  // SCALE TOOL APPLICABLE ITEM TYPES
  async function runSelectItemsForScale(selection) {
    if (!selection) {
      return [];
    }
    if (selection.length === 0) {
      setScaleItems(selection);
      return selection;
    }
    if (selection.length > 0) {
      let reorderedList = await sortLeftRightTopBottom(selection);
      let filteredSelection = reorderedList.filter(
        (item) =>
          (item.type === "sticky_note" && item.parentId === null) ||
          (item.type === "text" && item.parentId === null) ||
          (item.type === "card" && item.parentId === null) ||
          (item.type === "shape" && item.parentId === null) ||
          (item.type === "frame" && item.childrenIds.length === 0) ||
          (item.type === "image" && item.parentId === null)
      );
      // setBoardSelection(filteredSelection);
      setScaleItems(filteredSelection);
      return filteredSelection;
    }
  }
  // SCALE TOOL APPICABLE ITEM TYPE ICONS TO MATCH
  const scaleItemTypeIcons = (
    <div className="cs5 ce12 grid">
      <div className="m2 icon icon-rectangle cs1"></div>
      <div className="m2 icon icon-sticky-bulk cs2"></div>
      <div className="m2 icon icon-card cs3"></div>
      <div className="m2 icon icon-frame cs4"></div>
      <div className="m2 icon icon-text cs5"></div>
      <div className="m2 icon icon-image cs6"></div>
    </div>
  );

  async function runScale() {
    // let selection = await board.getSelection();
    let selection = await board.getSelection();
    let filteredSelection = await runSelectItemsForScale(selection);
    // filter for things

    //compute origin
    let origin = { x: 0, y: 0 };
    let xMinBoundsArray = [];
    let yMaxBoundsArray = [];
    filteredSelection.forEach((item) => {
      // compute left bound: x - (.5 * width) -- push to Min
      let leftBound = item.x - 0.5 * item.width;
      xMinBoundsArray.push(leftBound);
      // compute bottom bound: y + (.5 * height) -- push to yMaxBoundsArray
      let bottomBound = item.y + 0.5 * item.height;
      yMaxBoundsArray.push(bottomBound);
    });

    // sort those bounds arrays
    let leftMostBound = Math.min(...xMinBoundsArray);
    let bottomMostBound = Math.max(...yMaxBoundsArray);

    origin.x = leftMostBound;
    origin.y = bottomMostBound;

    filteredSelection.forEach((item) => {
      if (
        item.type === "sticky_note" ||
        item.type === "card" ||
        item.type === "image"
      ) {
        if (scaleInPlacechecked === false) {
          let itemXOffset = (item.x - origin.x) * scaleAmount;
          let itemYOffset = (origin.y - item.y) * scaleAmount;
          item.x = origin.x + itemXOffset;
          item.y = origin.y - itemYOffset;
        }
        item.width = item.width * scaleAmount;
        // item.height = item.height * scaleAmount;
        item.sync();
      } else if (item.type === "shape" || item.type === "frame") {
        if (scaleInPlacechecked === false) {
          let itemXOffset = (item.x - origin.x) * scaleAmount;
          let itemYOffset = (origin.y - item.y) * scaleAmount;
          item.x = origin.x + itemXOffset;
          item.y = origin.y - itemYOffset;
        }
        item.width = item.width * scaleAmount;
        item.height = item.height * scaleAmount;
        item.sync();
      } else if (item.type === "text") {
        if (scaleInPlacechecked === false) {
          let itemXOffset = (item.x - origin.x) * scaleAmount;
          let itemYOffset = (origin.y - item.y) * scaleAmount;
          item.x = origin.x + itemXOffset;
          item.y = origin.y - itemYOffset;
        }
        item.width = item.width * scaleAmount;
        item.height = item.height * scaleAmount;
        item.style.fontSize = item.style.fontSize * scaleAmount;
        item.sync();
      }
    });
  }
  return (
    <div id="scale-tool" className="grid tool-section mt-0 pb-0">
      <div
        id="scale-tool-header"
        className={"grid cs1 ce12 mt-0 cursor-pointer"}
        onClick={(event) => {
          handleToggleOpen();
        }}>
        <div className="icon m2 icon-expand cs1"></div>
        <h3 className="h3 cs2 ce11 mb-0 mt-0">Scale Items</h3>
        <div
          className={
            "cs12 icon m2 mb-0 mt-0 cursor-pointer" +
            " " +
            (toolOpen === false ? " icon-arrow-right" : " icon-arrow-down")
          }></div>
        {/* <p className="p-medium mt-0 pt-0 cs1 ce12 mb-0">
          X is the multiplier.
        </p> */}
      </div>
      <div
        id="accordion-content"
        ref={content}
        style={{ maxHeight: `${setHeight}` }}
        className="cs1 ce12 grid accordion">
        <div className="cs1 ce12 grid mb-8">
          <div
            id="scale-works-on"
            className="help-container grid cs1 ce12 mt-0 mb-8 pt-8">
            <p className="p-small cs1 ce4 mb-0 mt-0">
              Works on
              <b> many:</b>
            </p>
            {scaleItemTypeIcons}
            <p
              className="p-medium cs1 ce12 align-center mb-0 mt-0 "
              style={{
                color:
                  scaleItems.length < 1 ? "var(--red900)" : "var(--indigo600)",
              }}>
              <b>{scaleItems.length} scalable</b> item
              <>
                {scaleItems.length === 0 || scaleItems.length > 1 ? "s" : ""}{" "}
                selected.
              </>
            </p>
          </div>
          {/*  */}

          <input
            name="copies"
            type="number"
            className="cs1 ce3 input input-small ml-2"
            placeholder="1"
            min=".1"
            max="100"
            value={scaleAmount}
            onChange={(e) => setScaleAmount(e.target.value)}
          />
          <h2 className="cs4 h2 ml-8 mt-8 mb-8">
            <b>X</b>
          </h2>
          <div className="cs1 ce7 grid">
            {/* <p className="p-medium cs1 ce12 mb-0 mt-0 softer-help">
            Default: scales up & right.
          </p> */}

            <label className="toggle mb-0 cs1 ce12 ml-0">
              <input
                type="checkbox"
                tabIndex="0"
                onChange={handleScaleInPlaceChange}
              />
              <span>Scale items in place</span>
            </label>
          </div>
          <button
            type="button"
            className="button button-primary button-small cs1 ce12 mt-8 mb-0"
            onClick={runScale}>
            Scale it!
          </button>
        </div>
      </div>
    </div>
  );
}

export default Scale;
